/**
 * Servicio para gestión de certificados digitales y firma de facturas
 */

/**
 * Descarga un archivo XML
 */
export function downloadXML(xmlContent: string, filename: string) {
  const blob = new Blob([xmlContent], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * Valida que un certificado PEM tenga el formato correcto
 */
export function validatePEMFormat(pem: string, type: 'certificate' | 'key'): boolean {
  const certificateRegex = /^-----BEGIN CERTIFICATE-----[\s\S]+-----END CERTIFICATE-----$/;
  const keyRegex = /^-----BEGIN (RSA |EC |)PRIVATE KEY-----[\s\S]+-----END (RSA |EC |)PRIVATE KEY-----$/;

  const regex = type === 'certificate' ? certificateRegex : keyRegex;
  return regex.test(pem.trim());
}

/**
 * Obtiene información legible del subject de un certificado
 */
export function formatCertificateSubject(subject: string): string {
  // Extrae el CN (Common Name) del subject
  const cnMatch = subject.match(/CN=([^,]+)/);
  if (cnMatch) {
    return cnMatch[1];
  }
  return subject;
}

/**
 * Obtiene información legible del issuer de un certificado
 */
export function formatCertificateIssuer(issuer: string): string {
  // Extrae el O (Organization) del issuer
  const oMatch = issuer.match(/O=([^,]+)/);
  if (oMatch) {
    return oMatch[1];
  }
  return issuer;
}

/**
 * Valida que el contenido de un archivo sea texto
 */
export function isValidTextFile(file: File): Promise<boolean> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target?.result as string;
      resolve(typeof content === 'string' && content.length > 0);
    };
    reader.onerror = () => resolve(false);
    reader.readAsText(file);
  });
}
